import { render } from "./Parternship.vue?vue&type=template&id=2b31e9a0&scoped=true"
import script from "./Parternship.vue?vue&type=script&lang=js"
export * from "./Parternship.vue?vue&type=script&lang=js"

import "./Parternship.vue?vue&type=style&index=0&id=2b31e9a0&lang=scss&scoped=true"
import "./Parternship.vue?vue&type=style&index=1&id=2b31e9a0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b31e9a0"]])

export default __exports__